import { render, staticRenderFns } from "./_medication_form.vue?vue&type=template&id=475b9652&lang=pug"
import script from "./_medication_form.vue?vue&type=script&lang=js"
export * from "./_medication_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports